export const HEARTBEAT_INTERVAL_MS = 10_000;

// Must stay below HEARTBEAT_INTERVAL_MS so each heartbeat settles before the next one is due
export const HEARTBEAT_RESPONSE_TIMEOUT_MS = 5000;

export const HEARTBEAT_MAX_CONSECUTIVE_MISSES = 2;

export const WEBSOCKET_AUTHENTICATION_REJECTED = 'Authentication rejected';

export const WEBSOCKET_RECONNECT_DELAY_MS = 5000;

// Grace period before surfacing the connection lost overlay, so brief blips don't flash it
export const CONNECTION_LOST_OVERLAY_GRACE_MS = 2000;
